import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore } from 'firebase/firestore'; 

const firebaseConfig = {
  apiKey: "AIzaSyCA9yXGtybqjlou569OfBwANhL0m-CYktY",
  authDomain: "skybridge-solutions.firebaseapp.com",
  projectId: "skybridge-solutions",
  storageBucket: "skybridge-solutions.firebasestorage.app",
  messagingSenderId: "622831265240",
  appId: "1:622831265240:web:49f732975f0b667be17ead",
  measurementId: "G-GHFRSV92X1"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export { onAuthStateChanged };
export const db = getFirestore(app);